import React, { useEffect, useState, useImperativeHandle, useRef, useCallback } from "react";

import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import update from "immutability-helper";

import Rows from "./DnDTables/SO";

import SearchableSelect from "util/component/SearchableSelect";

import ModalPortal from "util/component/Modal";
import { Confirm } from "util/component/Modal/Modal";

import { useDidMountEffect } from "util";

import axios from 'util/axios';
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

const chkBegin = (data) => {
    let chk = [];
    data.forEach((d, i) => {
        if (d.repeat === "Y") {
            chk.push(i);
        }
    });
    if (chk.length < 2) {
        return data;
    } else {
        let returnData = [...data];
/*        for (let i = chk[0] + 1; i < chk[chk.length - 1]; i++) {
            returnData = update(returnData, {
                [i]: { repeat: { $set: "Y" } },
            });
        }*/
        return returnData;
    }
};

const CustomInput = (props) => {
    const [_value, _setValue] = useState(props.value);
    const _input = useRef(null);
    const dispatch = useDispatch();
    const _onFocus = (e) => {
        try {
            dispatch({ type: "FOCUS_TD", td: _input.current });
        } catch (e) {}
    };
    const _onBlur = (e) => {
        dispatch({ type: "BLUR_TD" });
        props.changed("desc", e.target);
    };
    useEffect(() => {
        _setValue(props.value);
    }, [props.value]);

    const autoResizeTextarea = (e) => {
        const textarea = e.target;
        textarea.style.height = "12px";
        let height = textarea.scrollHeight; // 높이
        if (height < 12) {
            height = 12;
        }
        textarea.style.height = `${height}px`;
    };

    return (
        <textarea
            ref={_input}
            type="text"
            value={_value}
            onChange={(e) => {
                _setValue(e.target.value);
            }}
            onFocus={_onFocus}
            onBlur={_onBlur}
            onKeyUp={autoResizeTextarea}
            name="desc"
            style={{ height: (_input.current?.scrollHeight || "12") + "px" }}
            placeholder="Description"
        />
    );
};

const repeatYN = [
    { value: "N", label: "N" },
    { value: "Y", label: "Y" },
];

const SOTable = (props, _ref) => {
    const { t } = useTranslation(["page"]);
    const { onChg, unit, onChangeListener, up, pr, cycle,onOpen,soSelected, handleClickSQTable, RevCmptCheckList,isCopy,isSheetCode } = props;
    const [ModalOpen, SetModalOpen] = useState(false);
    const [ModalMsg, SetModalMsg] = useState(<p></p>);

    const [_tblData, _setTblData] = useState([]);
    const [_isTblData, _setIsTblData] = useState(false);

    useImperativeHandle(_ref, () => ({
        setData: (data,isCopy) => {
            _setIsTblData(false);

            let newData = data.map((v, i) => {
                if (!v.tempUniqCode) {
                    v.tempUniqCode = Math.random().toString(36).substring(2, 13);
                }
                if(isCopy === "Y" && v.interfaceCode){
                    v.interfaceCode ="";
                }
                return v;
            });
            _setTblData([...newData]);
        },
        getData: () => {
            return _tblData;
        },
        refreshData: () => {
            _setTblData((T) => {
                return T.map((d) => {
                    return { ...d, timeStamp: Date.parse(new Date()) };
                });
            });
        },
        resetData:() =>{
            _setTblData((d) => []);
            SetSOOptions((d) => []);
        }
    }));

    




    // seqCode 부여 logic
    const seqCodeAlgorithm = () => {
        let array = [];
        let seqCode = 0;
        let startY = 0;
        let endY = startY;
        let isFlag = false;
        for (let i = 0; i <= _tblData.length; i++) {
            if (i !== _tblData.length && _tblData[i].repeat === "Y") {
                isFlag = true;
                endY++;
            } else {
                // 반복 시 startY, endY까지 찍는다.
                if (isFlag) {
                    let arrayTemp = new Array((endY - startY)).fill("");
                    for (let initRepeat = 0; initRepeat < cycle; initRepeat++) {
                        let indexY = 0; 
                        for (let y = startY; y < endY; y++) {
                            seqCode++;
                            if (initRepeat === cycle - 1) {
                                arrayTemp[indexY++] += (('00' + (seqCode)).slice(-2)+"A");
                            } else {
                                arrayTemp[indexY++] += (('00' + (seqCode)).slice(-2)+"A" + " ");
                            }
                            // Y 값
                        }
                    }
                    arrayTemp.forEach((arr) => {array.push(arr)})
                    seqCode++;
                    array.push((('00' + (seqCode)).slice(-2)+"A"))
                } else if (startY === 0) {
                    seqCode++
                    array.push((('00' + (seqCode)).slice(-2)+"A"));
                } else {
                    if (i === _tblData.length)
                        continue;
                    seqCode++;
                    array.push((('00' + (seqCode)).slice(-2)+"A"));
                }
                isFlag = false;
                startY = i + 1;
                endY = startY;
            }
        }

        
        _setTblData((T) => {

            return T.map((d,i) => {
                /*
                * 이동원 그룹장 요청으로 모든 code 보이게
                * return { ...d, seqCode: (array[i].toString().split(" ")[0] + (array[i].toString().split(" ").length > 1 ? " " + array[i].toString().split(" ")[array[i].toString().split(" ").length-1] : "")) };
                */
                
                return {...d, seqCode: array[i].toString().split(" ").join(",")
            }
            });
        });
    }
    // seqCode 부여 logic 끝

    /* 
    code 변경 관련 추가
    const soSeqOrder = (seq) => {
        seqLogics();
        if (!!seq) {

            return ('S'+('00' + (seq-1)).slice(-2));
        } else {
            let i = index+1;
            return ('S'+('00' + i).slice(-2));
            return ('S'+('00' + i++).slice(-2));
        }
    }
     code 변경 관련 제거
     */ 

    const [SOOptions, SetSOOptions] = useState([]);

    const [SOData, setSOData] = useState({
        label: null,
        code: null,
        desc: "",
        repeat: "N",
        tempUniqCode: "",
        interfaceCode : "",
    });

    const initialData = (isFirst = false) => {
        setSOData({
            label: null,
            code: null,
            desc: "",
            repeat: "N",
            inRemark: "FALSE",
            outRemark: "FALSE",
            qcRemark: "FALSE",
            tempUniqCode: "",
            interfaceCode : "",
        });
        if (isFirst) {
            getSOOptions();
        }
    };
    const getSOOptions = useCallback(() => {
        
        axios
            .post(
                process.env.REACT_APP_API + "/common/retrieveMasterCodeList",
                {
                    grcd: unit,
                    disableYn: "N"
                }
            )
            .then((response) => {
                const data = response.data.data.result;
                if (data.length > 0) {
                    const genSeq = data.findIndex(
                        (e) =>
                            e.label?.toLowerCase() === "general".toLowerCase()
                    );
                    let data2;
                    if (genSeq > -1) {
                        data2 = update(data, {
                            $splice: [[genSeq, 1]],
                        });
                    } else {
                        data2 = data;
                    }
                    if (!up) {
                        _setTblData((d) =>
                            update(d, {
                                $set: [
                                    {
                                        label: data[0].label,
                                        code: data[0].value,
                                        desc: data[0].label,
                                        inRemark: "FALSE",
                                        outRemark: "FALSE",
                                        qcRemark: "FALSE",
                                        repeat: "N",
                                        tempUniqCode: Math.random()
                                            .toString(36)
                                            .substring(2, 13),
                                    },
                                ],
                            })
                        );
                        onChangeListener("add", data[0].value);
                    }

                    SetSOOptions((d) => [...data2]);
                } else {
                    //확인필요
                    // if (!up) {
                    //     _setTblData((d) => []);
                    // }
                    SetSOOptions((d) => []);
                }
            });
    },[unit,up]);

    useEffect(() => {
        if (!up) {
            onChangeListener("init");
            initialData(true);
        } else {
            getSOOptions();
        }
    }, [unit,up]);

    const AddSOParam = useCallback(() => {
        if (!SOData.code) {
            return;
        } else {
            if(SOData.target === 'step'){
                //onChangeListener("add", SOData.code);
                _setTblData((TD) =>
                    update(TD, {
                        [SOData.index]: {$merge: { ...SOData,
                                tempUniqCode: Math.random()
                                    .toString(36)
                                    .substring(2, 13), }
                        },
                    })
                );

            }else{
                onChangeListener("add", SOData.code);
                _setTblData((d) =>
                    update(d, {
                        $push: [
                            {
                                ...SOData,
                                tempUniqCode: Math.random()
                                    .toString(36)
                                    .substring(2, 13),
                            },
                        ],
                    })
                );
            }

            initialData(false);
        }
    },[SOData, onChangeListener]);

    const moveRow = (dragIndex, hoverIndex) => {
        _setTblData((_TD) =>
            update(_TD, {
                $splice: [
                    [dragIndex, 1],
                    [hoverIndex, 0, _TD[dragIndex]],
                ],
            })
        );
        onChangeListener("move", { dragIndex, hoverIndex });
    };

    const changed = (e, i) => {
        if (e.target.name === "desc") {
            _setTblData((TD) =>
                update(TD, {
                    [i]: {
                        desc: { $set: e.target.value },
                    },
                })
            );
        } else if (e.target.name === "repeat") {
            _setTblData((TD) => {
                let origin = update(TD, {
                    [i]: { repeat: { $set: e.target.value } },
                });
                if (e.target.value === "Y") {
                    origin = chkBegin(origin);
                }
                return origin;
            });
        }else if(e.target.name === "step"){
            onChangeListener("reset", i);
            let d= { label: e.target.value.label, code: e.target.value.value, desc: e.target.value.label,target:e.target.name,index:i };
            setSOData((SOD) =>
                update(SOD, {
                    $merge: d,
                })
            );

        }
    };

    const deleteRow = (i) => {
        SetModalMsg(
            <Confirm
                onClose={() => SetModalOpen(false)}
                onConfirm={() => deleteRowConfirm(i)}
            >
                <p>{t("delete")}</p>
            </Confirm>
        );
        SetModalOpen(true);
    };
    const deleteRowConfirm = (i) => {
        onChangeListener("remove", i);
        _setTblData((T) =>
            update(T, {
                $splice: [[i, 1]],
            })
        );
        SetModalOpen(false);
    };
    const copyRow = (idx) => {
        onChangeListener("copy", _tblData[idx]);
        _setTblData((T) =>
            update(T, {
                $push: [
                    {
                        ..._tblData[idx],
                        tempUniqCode: Math.random().toString(36).substring(2, 13),
                        uniqueCode: '',
                        interfaceCode:''
                    },
                ],
            })
        );
    };

    const soChanged = (name, val) => {
        let d;
        if (name === "so") {
            d = { label: val.label, code: val.value, desc: val.label };
        } else {
            d = { [name]: val.value };
        }
        setSOData((SOD) =>
            update(SOD, {
                $merge: d,
            })
        );
    };
    const onOpenWrapper = (vv,index,dataIndex,sheetType) => {
        onOpen(vv,index,dataIndex,sheetType,_tblData,'SO');
    }

    useEffect(() => {
        if (SOData.code) {
            AddSOParam();
        }
    }, [AddSOParam, SOData.code]);

    useEffect(() => {
        if(_tblData.length > 0){
            if (_isTblData) {
                seqCodeAlgorithm(); // 코드 넣기 추기
                _setIsTblData(!_isTblData);
            } else {
                onChg(_tblData);
                _setIsTblData(!_isTblData);
            }
        }

    }, [_tblData]);

    return (
        <DndProvider backend={HTML5Backend}>
            <table id="so-table">
                <colgroup>
                   
                    <col width={"40px"} />
                    {/*<col width={"100px"} />*/}
                    <col width={"30%"} />
                    <col />
                    <col width={"80px"} />
                    <col width={"30px"} />
                    <col width={"30px"} />
                </colgroup>
                <thead>
                    <tr>
                        <th>Seq</th>
                        {/*<th>Code</th>*/}
                        <th>Step Operation</th>
                        <th>Step Operation Description</th>
                        <th>Repeat</th>
                        <th className="actions"></th>
                        <th className="actions"></th>
                    </tr>
                </thead>
                <tbody>
                    {_tblData?.map((v, i) => {
                        if (!!v.tempUniqCode) {
                            return (
                                <Rows
                                    // soSeqOrder={soSeqOrder}
                                    // seqCodeAlgorithm={seqCodeAlgorithm}
                                    // seqCode={seqCode[i]}
                                    index={i}
                                    rowData={v}
                                    moveRow={moveRow}
                                    changed={changed}
                                    deleted={deleteRow}
                                    copied={copyRow}
                                    key={"sotable-" + i}
                                    pr={pr}
                                    onOpen = {onOpenWrapper}
                                    soSelected = {soSelected}
                                    handleClickSQTable = {handleClickSQTable}
                                    RevCmptCheckList = {RevCmptCheckList}
                                    isCopy = {isCopy}
                                    isSheetCode = {isSheetCode}
                                    SOOptions = {SOOptions}
                                    soChanged = {soChanged}
                                />
                            );
                        }
                    })}
                </tbody>

                {_tblData.length > 0 && (
                    <tfoot>
                        <tr>
                            <td>{_tblData.length + 1}</td>
{/*                            <td>
                                 <input type="text" defaultValue={"s"+('00' + index).slice(-2)} className="so-code " readOnly />
                            </td>*/}
                            <td>
                                <SearchableSelect
                                    value={SOData.code}
                                    onChange={(val) => soChanged("so", val)}
                                    search={true}
                                    options={SOOptions}
                                    name="so"
                                />
                            </td>
                            <td>
                                <CustomInput
                                    value={SOData.desc}
                                    changed={soChanged}
                                />
                            </td>
                            <td
                                style={
                                    pr === "USP"
                                        ? { backgroundColor: "#0001" }
                                        : null
                                }
                            >
                                <SearchableSelect
                                    value={SOData.repeat}
                                    onChange={(val) => soChanged("repeat", val)}
                                    options={repeatYN}
                                    isDisabled={pr === "USP"}
                                    textAlign={"center"}
                                    name="repeat"
                                />
                            </td>
                            <td className="actions"></td>
                            <td className="actions"></td>
                        </tr>
                        {/* <tr id="so-add-tr">
                        <td colSpan="4" className="add" onClick={AddSOParam}>+ Add Sequence</td>
                        <td></td>
                    </tr> */}
                    </tfoot>
                )}
            </table>
            {ModalOpen && <ModalPortal>{ModalMsg}</ModalPortal>}
        </DndProvider>
    );
};

export default React.forwardRef(SOTable);
